import { convertTimeToMMSS } from '@src/utility/timeFormat';

import type { TooltipEntry } from '../common/ClipContextTooltip';
import type { ClipMetadata } from '@src/types.ts/story';

/**
 * The reel badge overlay's clip list: one row per contributing clip, in the
 * order they play — position, the clip's name, and how long its piece runs.
 *
 * The name is the PLAT-11067 origin lineage's most recent entry — the clip (or
 * reel) that was actually combined in, which is the answer to "what is this
 * reel made of". Reels saved before origins existed fall back to the piece's
 * theme, and failing that to its position, so a legacy reel still lists as
 * many rows as it has pieces rather than pretending it has none.
 */
export function reelClipRows(clipJson?: ClipMetadata): TooltipEntry[] {
  if (!clipJson?.isReel || !clipJson.subClips?.length) return [];
  return clipJson.subClips.map((sub, i) => ({
    label: String(i + 1),
    value: sub.origin?.[0]?.title || sub.theme || `Clip ${i + 1}`,
    note: convertTimeToMMSS(Math.round(sub.duration)),
  }));
}
